import React, { forwardRef, InputHTMLAttributes } from 'react';
import { useId } from 'react-id-generator';
import { Label } from './Label';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helper?: string;
  littleTop?: boolean;
}

/**
 * @example
 * <Checkbox
 *   label="Checkbox"
 *   onChange={(e) => console.log(e.target.checked)}
 * />
 */
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className = '', label, helper, littleTop, ...props }, ref) => {
    const [id] = useId(1, 'checkbox');

    return (
      <div className="relative label-col">
        <div className="label-row">
          <input
            ref={ref}
            id={id}
            type="checkbox"
            className={`checkbox ${className}`}
            {...props}
          />
          {label && <Label htmlFor={id} text={label} />}
        </div>
        {helper && (
          <p
            className={`absolute w-max ${
              littleTop ? 'top-5' : 'top-7'
            } left-7 text-sm text-error`}
          >
            {helper}
          </p>
        )}
      </div>
    );
  },
);
